/**
 * @generated SignedSource<<7a0aca1af52fb18f13534b5bf7fede2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SurgeryTimelineFragment$data = {
  readonly id: string;
  readonly name: string | null | undefined;
  readonly operatingRooms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SurgeryTimelineFragment";
};
export type SurgeryTimelineFragment$key = {
  readonly " $data"?: SurgeryTimelineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SurgeryTimelineFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "numberOfOperatingRooms"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SurgeryTimelineFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "numberOfOperatingRooms"
        }
      ],
      "concreteType": "LocationConnection",
      "kind": "LinkedField",
      "name": "operatingRooms",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Location",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Hospital",
  "abstractKey": null
};
})();

(node as any).hash = "415d9bdbdd99c60bec619d1bedf76345";

export default node;
